import * as React from 'react'
import classNames from 'classnames'
import './statusChip.scss'

export type StatusChipTone = 'success' | 'warning' | 'neutral' | 'info' | 'error'

interface StatusChipProps {
    label: string
    tone: StatusChipTone
    className?: string
}

export function StatusChip({ label, tone, className }: StatusChipProps) {
    return <span className={classNames('status-chip', tone, className)}>{label}</span>
}
